export default __webpack_public_path__ + "static/media/image (4).1e640fb1.png";